export const environment = {
  production: true,
  staging: false,
  baseUrl: 'https://morf.gjuhashqipe.com/',
  apiUrl: 'https://morfapi.gjuhashqipe.com/api/',
  signalRUrl: "https://morfapi.gjuhashqipe.com/morfologjiahub",
  ssoUrl: 'https://sso.gjuhashqipe.com',
};
